import { Stack, Typography } from '@mui/material';
import React from 'react';
import { PRIMARY_COLOR } from '../constants';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export default function HeadingWithDescription({
  heading,
  description,
  customColor,
  customSizeHeading,
  customFontWeightHeading,
  customFunc,
  showBackBtn = true,
  backBtnColor = '#000',
}: {
  heading: string;
  customColor?: string;
  description?: string;
  customSizeHeading?: number | string;
  customFontWeightHeading?: number | string;
  customFunc?: any;
  showBackBtn?: boolean;
  backBtnColor?: string;
}) {
  const navigate = useNavigate();
  return (
    <Stack direction={'row'} alignItems={'center'} gap={2}>
      {showBackBtn && (
        <div onClick={() => (customFunc ? customFunc() : navigate(-1))}>
          <ArrowBack sx={{ color: backBtnColor }} />
        </div>
      )}
      <Stack flex={1}>
        <Typography
          fontSize={customSizeHeading}
          variant="h5"
          fontWeight={customFontWeightHeading ?? '400'}
        >
          {heading}
        </Typography>
        <Typography
          fontSize={'14px'}
          variant="caption"
          color={customColor ? customColor : PRIMARY_COLOR}
        >
          {description}
        </Typography>
      </Stack>
    </Stack>
  );
}
